// @ts-nocheck
import { Box, Button, Modal, Typography } from "@mui/material";
import "./calendar.css";
import PropTypes from "prop-types";
import FullCalendar from "@fullcalendar/react";
import dayGridPlugin from "@fullcalendar/daygrid";
import timeGridPlugin from "@fullcalendar/timegrid";
import interactionPlugin from "@fullcalendar/interaction";
import { useMediaQuery } from "@mui/material";
import { useState } from "react";
import { useEffect } from "react";
import { apiRequest } from "../../../services/apiService";
import { alertDialogAciton } from "../../../store/actions/auth";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import LoadingOverlay from "../../../components/Custom/LoadingOverlay";
import dayjs from "dayjs";
import { HoldDownShift } from "./_components/HoldDownShift";
import { isTimeTBD } from "../../../appCalcutions";
// import CalendarMiddleware from "./CalendarMiddleware";

const sx = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  minWidth: "90%",
  minHeight: "60vh",
  // maxHeight: "90vh",
  maxWidth: "1600px",
  // aspectRatio: "1/1",
  boxShadow: 24,
  p: 4,
  // maxWidth: "2000px",
  borderRadius: "16px",
  padding: "20px",
  border: "2px solid #D175B6",
  backgroundColor: "#000",
  zIndex: 5,
  overflowY: "auto",
  "@media (max-width: 600px)": {
    minWidth: "0px",
    minHeight: "40vh",
    width: "97vw",
    // maxHeight: "95vh",
    overflowY: "auto",
  },
};

export default function Calendar({ open, handleClose, setMiddleware }) {
  const isSmallScreen = useMediaQuery((theme) => theme.breakpoints.down("sm"));
  const isMediumScreen = useMediaQuery((theme) => theme.breakpoints.down("md"));

  const { userId } = useSelector((state) => state.auth);

  // state variables start...
  const [allEvents, setAllEvents] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [holdShift, setHoldShift] = useState(false);
  const [holdAndPre, setHoldAndPre] = useState([]);
  // const [middlewareStartDate, setMiddlewareStartDate] = React.useState();
  // const [middlewareType, setMiddlewareType] = React.useState();
  // const [middleware, setMiddleware] = React.useState({
  //   state: null
  // });
  // state variables end...

  const COLOR = {
    SCHEDULED: {
      bg: "#4caf50",
      border: "#388e3c",
    },
    APPLIED: {
      bg: "#2196f3",
      border: "#1976d2",
    },
    IN_PROGRESS: {
      bg: "#ff9800",
      border: "#f57c00",
    },
    NOT_RESPONDED: {
      bg: "#504c4c",
      border: "#504c4c",
    },
  };

  const dispatch = useDispatch();
  const navigate = useNavigate();

  const handleDateClick = (info) => {
    const calendarApi = info.view.calendar;
    calendarApi.changeView("timeGridDay", info.dateStr);
  };

  function getStatusColor(type) {
    switch (type.toLowerCase()) {
      case "applied":
        return [COLOR.APPLIED.bg, COLOR.APPLIED.border];
      case "partially responded":
        return [COLOR.IN_PROGRESS.bg, COLOR.IN_PROGRESS.border];
      case "not responded":
        return [COLOR.NOT_RESPONDED.bg, COLOR.NOT_RESPONDED.border];
      default:
        return [COLOR.SCHEDULED.bg, COLOR.SCHEDULED.border];
    }
  }

  function sanitizeEventsApi1(events) {
    return events.map((event) => {
      return {
        ...event,
        title: `${event?.positionOrder ? `${event?.positionName} - ${event?.positionOrder}` : event?.positionName}`,
        // ...(event?.timeIn &&
        //   event?.timeOut && {
        //     start: event?.timeIn,
        //     end: event?.timeOut,
        //   }),
        // ...(event?.timeIn &&
        //   event?.timeOut && {
        //     start: event?.timeIn,
        //     // end: event?.timeOut,
        //   }),
        ...(event?.startDate && {
          start: event?.startDate,
          // end: event?.timeOut,
        }),
        ...(!event?.timeIn &&
          !event?.timeOut && {
            allDay: true,
          }),
        _id: event?.id,
        type: "schedule",
        backgroundColor: COLOR.SCHEDULED.bg,
        borderColor: COLOR.SCHEDULED.border,
      };
    });
  }

  function sanitizePositionsApi2(positions) {
    const list = [];
    positions?.forEach((opp) => {
      opp?.positions?.forEach((pos) => {
        // const [backgroundColor, borderColor] = getStatusColor(
        //   opp?.opportunityStatus,
        // );

        const [backgroundColor, borderColor] = getStatusColor(
          getStatusText(pos?.response),
        );

        list.push({
          ...opp,
          ...pos,
          // ...(pos?.timeIn &&
          //   pos?.timeOut && {
          //     start: pos?.timeIn,
          //     end: pos?.timeOut,
          //   }),
          // ...(pos?.timeIn &&
          //   pos?.timeOut && {
          //     start: pos?.timeIn,
          //     // end: pos?.timeOut,
          //   }),
          ...(pos?.startDate && {
            start: pos?.startDate,
            // end: pos?.timeOut,
          }),
          ...(!pos?.timeIn &&
            !pos?.timeOut && {
              allDay: true,
            }),
          ...(isTimeTBD(pos?.timeOut) && {
            allDay: true,
            start: pos?.startDate,
          }),
          title: `${pos?.positionOrder ? `${pos?.positionName} - ${pos?.positionOrder}` : pos?.positionName}`,
          type: getStatusText(pos?.response),
          backgroundColor,
          borderColor,
          venue: opp.sessionVenue ?? opp?.venue,
          venueAddressLine1:
            opp.sessionVenueAddressLine1 ?? opp?.venueAddressLine1,
          venueAddressLine2:
            opp.sessionVenueAddressLine2 ?? opp?.venueAddressLine2,
          venueCity: opp.sessionVenueCity ?? opp?.venueCity,
          venueState: opp.sessionVenueState ?? opp?.venueState,
          venueZipCode: opp.sessionVenueZipCode ?? opp?.venueZipCode,
          lat: opp.sessionLat ?? opp?.lat,
          long: opp.sessionLong ?? opp?.long,
        });
      });
    });
    return list;
  }

  function sanitizeHoldingApi3(holdList) {
    setHoldAndPre(
      holdList?.map((item) => ({
        start: dayjs(item?.date?.split("T")?.[0]).toDate(),
        type: item?.holdDownShift === "holdDown" ? "holdDown" : "preBook",
        message: item?.comment,
        data: item,
      })),
    );
  }

  function getStatusText(response) {
    if (response?.applied) {
      return "applied";
    } else if (response?.pending) {
      return "not responded";
    } else {
      return "in progress";
    }
  }

  // const getCurrentMonthRange = (month) => {
  //   const [year, monthIndex] = month.split("-");
  //   const start = new Date(year, monthIndex - 1, 1);
  //
  //   const end = new Date(year, monthIndex, 0);
  //
  //   const startDate = start.toISOString().split("T")[0];
  //   const endDate = end.toISOString().split("T")[0];
  //
  //   return { start: startDate, end: endDate };
  // };

  const fetchEvents = async () => {
    setIsLoading(true);

    // Post-unify: we silence the "Failed to fetch data" alert because the Calendar
    // is rendered as a widget inside LayoutContractor — any multi-role user
    // logged in as a contractor with no data (not a real contractor) caused an
    // intrusive popup. We just log it and continue with an empty list.
    try {
      const [a1, a2, a3] = await Promise.all([
        apiRequest({
          method: "GET",
          url: `getPositionsOfAssignedContractor`,
          data: null,
          isToken: true,
        }),
        apiRequest({
          method: "GET",
          url: `getPendingAppliedOpportunities`,
          data: null,
          isToken: true,
        }),
        apiRequest({
          method: "GET",
          url: "getSpecificPreBookContractors",
          params: { contractorId: userId },
          isToken: true,
        }),
      ]);

      if (a1?.error || a2?.error || a3?.error) {
        // eslint-disable-next-line no-console
        console.warn("[Calendar] partial fetch error", {
          a1: a1?.error,
          a2: a2?.error,
          a3: a3?.error,
        });
      }

      try {
        sanitizeHoldingApi3(a3?.response?.data?.data);
      } catch (_) {}
      const combinedEvents = [
        ...(sanitizeEventsApi1(a1?.response?.data?.eventData) || []),
        ...(sanitizePositionsApi2(a2?.response?.data?.data) || []),
      ];

      setAllEvents(() => [...combinedEvents]);
    } catch (error) {
      // eslint-disable-next-line no-console
      console.error("[Calendar] fetchEvents fatal", error);
    } finally {
      setIsLoading(false);
    }
  };

  const filterEventsOfADate = (date) => {
    const foundHold = holdAndPre?.find(
      (d) =>
        dayjs(d?.start).format("YYYY-MM-DD") ===
        dayjs(date).format("YYYY-MM-DD"),
    );

    if (!date && !foundHold) {
      return;
    }

    const positionsForGivenDate = {
      schedule: [],
      multiple: [],
      single: null,
    };

    allEvents?.map((event) => {
      const middlewareStartDt = new Date(date);
      const eventStartDt = new Date(event?.startDate);

      if (
        middlewareStartDt.getDate() === eventStartDt.getDate() &&
        middlewareStartDt.getFullYear() === eventStartDt.getFullYear() &&
        middlewareStartDt.getMonth() === eventStartDt.getMonth()
      ) {
        if (event?.type === "schedule") {
          positionsForGivenDate.schedule.push(event);
        } else {
          const isOpportunityAlreadyAdded =
            positionsForGivenDate?.multiple?.find((multipleItem) => {
              return multipleItem?.data?.eventId === event?.eventId;
            }) ||
            positionsForGivenDate?.single?.event?._id === event?.eventId ||
            positionsForGivenDate?.schedule?.find((item) => {
              return item?.eventId === event?.eventId;
            });

          if (isOpportunityAlreadyAdded) {
            return;
          }

          if (event?.positions?.length > 1) {
            positionsForGivenDate.multiple.push({
              data: {
                ...event,
                positions: event?.positions
                  ?.filter?.((position) => {
                    const positionStartDt = new Date(
                      position?.startDate?.split?.("T")?.[0],
                    );

                    return !(
                      middlewareStartDt.getDate() !==
                        positionStartDt.getDate() ||
                      middlewareStartDt.getFullYear() !==
                        positionStartDt.getFullYear() ||
                      middlewareStartDt.getMonth() !==
                        positionStartDt.getMonth()
                    );
                  })
                  ?.map((position) => {
                    return {
                      ...position,
                      type: position?.response?.applied
                        ? "applied"
                        : position?.response?.pending
                          ? "not responded"
                          : position?.response?.declined
                            ? "declined"
                            : "",
                    };
                  }),
              },
            });
          } else {
            positionsForGivenDate.single = {
              ...event,
              positions: event?.positions
                ?.filter?.((position) => {
                  const positionStartDt = new Date(
                    position?.startDate?.split?.("T")?.[0],
                  );

                  return !(
                    middlewareStartDt.getDate() !== positionStartDt.getDate() ||
                    middlewareStartDt.getFullYear() !==
                      positionStartDt.getFullYear() ||
                    middlewareStartDt.getMonth() !== positionStartDt.getMonth()
                  );
                })
                ?.map((position) => {
                  return {
                    ...position,
                    type: position?.response?.applied
                      ? "applied"
                      : position?.response?.pending
                        ? "not responded"
                        : position?.response?.declined
                          ? "declined"
                          : "",
                  };
                }),
            };
          }

          // event?.positions?.map(position => {
          //   const positionStartDt = new Date(position?.startDate?.split?.("T")?.[0]);

          //   if (middlewareStartDt.getDate() !== positionStartDt.getDate() ||
          //     middlewareStartDt.getFullYear() !== positionStartDt.getFullYear() ||
          //     middlewareStartDt.getMonth() !== positionStartDt.getMonth()
          //   ) {
          //     return;
          //   }

          //   const isOpportunityAlreadyAdded = positionsForGivenDate?.multiple?.find(multipleItem => {
          //     return multipleItem?.data?.eventId === event?.eventId;
          //   })

          //   if (!isOpportunityAlreadyAdded) {
          //     if (event?.positions?.length > 1) {
          //       // if (!positionsForGivenDate?.multiple?.data) {
          //       //   positionsForGivenDate.multiple.data = event;
          //       // }
          //       positionsForGivenDate.multiple.push({
          //         data: {
          //           ...event,
          //           positions: event?.positions?.map(position => {
          //             return {
          //               ...position,
          //               type: position?.response?.applied ? "applied" : (
          //                 position?.response?.pending ? "not responded" : (
          //                   position?.response?.declined ? "declined" : ""
          //                 )
          //               )
          //             }
          //           })
          //         }
          //       });
          //     } else {
          //       positionsForGivenDate.single = {
          //         ...event,
          //         positions: event?.positions?.map(position => {
          //           return {
          //             ...position,
          //             type: position?.response?.applied ? "applied" : (
          //               position?.response?.pending ? "not responded" : (
          //                 position?.response?.declined ? "declined" : ""
          //               )
          //             )
          //           }
          //         })
          //       };
          //     }
          //   }
          // });
        }
      }
    });

    const isNoData =
      !positionsForGivenDate?.single &&
      positionsForGivenDate?.multiple?.length == 0 &&
      positionsForGivenDate?.schedule?.length == 0;

    if (foundHold && isNoData) {
      setMiddleware((middleware) => {
        return {
          ...middleware,
          state: positionsForGivenDate,
          holdAndPre: foundHold?.data,
        };
      });
      return;
    } else if (isNoData) {
      return;
    }

    setMiddleware((middleware) => {
      return {
        ...middleware,
        state: positionsForGivenDate,
        holdAndPre: foundHold?.data,
      };
    });
    // handleClose();
  };

  useEffect(() => {
    fetchEvents();
  }, []);

  return (
    <>
      <Modal open={open} onClose={handleClose}>
        <Box sx={sx} className={"cal"}>
          {isLoading ? (
            <LoadingOverlay open={isLoading} />
          ) : (
            <>
              <FullCalendar
                headerToolbar={{
                  start: isSmallScreen ? "title" : "prev,next today",
                  center: isSmallScreen ? null : "title",
                  end: isSmallScreen
                    ? "prev,next"
                    : "refresh dayGridMonth,timeGridWeek,timeGridDay",
                }}
                footerToolbar={{
                  start: isSmallScreen
                    ? "dayGridMonth,timeGridWeek,timeGridDay"
                    : null,
                }}
                customButtons={{
                  refresh: {
                    text: "Refresh",
                    click: () => {
                      fetchEvents();
                    },
                  },
                }}
                plugins={[dayGridPlugin, timeGridPlugin, interactionPlugin]}
                initialView="dayGridMonth"
                events={allEvents}
                // dateClick={handleDateClick}
                eventDidMount={(info) => {
                  const eventEl = info.el;
                  const dotEl = eventEl.querySelector(".fc-daygrid-event-dot");

                  if (dotEl) {
                    const dotColor = getComputedStyle(dotEl).borderColor;
                    eventEl.style.backgroundColor = dotColor;
                    dotEl.style.display = "none";
                    eventEl.style.paddingLeft = "5px";
                  }
                }}
                dayMaxEvents={3}
                moreLinkContent={(args) => {
                  const count = args.num;
                  return `${count} more event${count > 1 ? "s" : ""}`;
                }}
                moreLinkClick={(info) => {
                  filterEventsOfADate(dayjs(info?.date).format("YYYY-MM-DD"));
                  if (info?.el?.classList?.contains("fc-more")) {
                    info?.el?.addEventListener("click", function (event) {
                      event.preventDefault();
                      event.stopPropagation();
                    });
                  }
                }}
                dateClick={(info) => {
                  filterEventsOfADate(info?.dateStr);
                }}
                eventClick={(info) => {
                  const data = info?.event?._def?.extendedProps;
                  const startDate =
                    data?.startDate || data?.positions?.[0]?.startDate;

                  filterEventsOfADate(startDate);
                }}
                dayCellDidMount={(info) => {
                  const formattedDate = dayjs(info.date).format("YYYY-MM-DD");

                  // Find if the date has holdDown or preBook
                  const specialEvent = holdAndPre?.find(
                    (item) =>
                      dayjs(item?.start).format("YYYY-MM-DD") === formattedDate,
                  );

                  if (!specialEvent) return;

                  const cellEl = info.el;

                  // Apply background color based on type
                  if (specialEvent.type === "holdDown") {
                    cellEl.style.backgroundColor = "#7d0000";
                  } else if (specialEvent.type === "preBook") {
                    cellEl.style.backgroundColor = "#eee100c7";
                  }
                  cellEl.style.cursor = "pointer";
                  // const tooltip = document.createElement("div");
                  // tooltip.classList.add("custom-tooltip");
                  // tooltip.innerText =
                  //   specialEvent?.message || "No message available";
                  // document.body.appendChild(tooltip);
                  //
                  // // Position tooltip on hover
                  // cellEl.addEventListener("mouseenter", (e) => {
                  //   tooltip.style.display = "block";
                  //   tooltip.style.left = `${e.pageX + 10}px`;
                  //   tooltip.style.top = `${e.pageY + 10}px`;
                  // });
                  //
                  // // Hide tooltip on mouse leave
                  // cellEl.addEventListener("mouseleave", () => {
                  //   tooltip.style.display = "none";
                  // });
                }}
              />

              <Box
                sx={{
                  display: "flex",
                  justifyContent: "space-between",
                  flexDirection: isMediumScreen ? "column" : "row",
                  gap: "1rem",
                  alignItems: "center",
                }}
              >
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    gap: "2rem",
                    flexDirection: isSmallScreen ? "column" : "row",
                    mt: isSmallScreen ? "1rem" : "0px",
                  }}
                >
                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      gap: "2rem",
                    }}
                  >
                    <Box
                      sx={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        gap: "0.5rem",
                      }}
                    >
                      <Box
                        sx={{
                          height: "1.5rem",
                          width: "1.5rem",
                          borderRadius: "0.5rem",
                          backgroundColor: COLOR.NOT_RESPONDED.bg,
                        }}
                      ></Box>
                      <Typography>Not Responded</Typography>
                    </Box>

                    <Box
                      sx={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        gap: "0.5rem",
                      }}
                    >
                      <Box
                        sx={{
                          height: "1.5rem",
                          width: "1.5rem",
                          borderRadius: "0.5rem",
                          backgroundColor: COLOR.IN_PROGRESS.bg,
                        }}
                      ></Box>
                      <Typography>Partially Responded</Typography>
                    </Box>
                  </Box>

                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      gap: "2rem",
                    }}
                  >
                    <Box
                      sx={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        gap: "0.5rem",
                      }}
                    >
                      <Box
                        sx={{
                          height: "1.5rem",
                          width: "1.5rem",
                          borderRadius: "0.5rem",
                          backgroundColor: COLOR.APPLIED.bg,
                        }}
                      ></Box>
                      <Typography>Applied</Typography>
                    </Box>

                    <Box
                      sx={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        gap: "0.5rem",
                      }}
                    >
                      <Box
                        sx={{
                          height: "1.5rem",
                          width: "1.5rem",
                          borderRadius: "0.5rem",
                          backgroundColor: COLOR.SCHEDULED.bg,
                        }}
                      ></Box>
                      <Typography>Scheduled</Typography>
                    </Box>
                  </Box>

                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      gap: "2rem",
                    }}
                  >
                    <Box
                      sx={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        gap: "0.5rem",
                      }}
                    >
                      <Box
                        sx={{
                          height: "1.5rem",
                          width: "1.5rem",
                          borderRadius: "0.5rem",
                          backgroundColor: "#eee100c7",
                        }}
                      ></Box>
                      <Typography>Pre booked</Typography>
                    </Box>

                    <Box
                      sx={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        gap: "0.5rem",
                      }}
                    >
                      <Box
                        sx={{
                          height: "1.5rem",
                          width: "1.5rem",
                          borderRadius: "0.5rem",
                          backgroundColor: "#7d0000",
                        }}
                      ></Box>
                      <Typography>Hold down shift</Typography>
                    </Box>
                  </Box>
                </Box>

                <Box
                  className="bottom-btn-box"
                  sx={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    margin: "0px !important",
                  }}
                >
                  <Button
                    className="btn-pink"
                    onClick={() => {
                      setHoldShift(true);
                    }}
                  >
                    Hold down shift
                  </Button>
                </Box>
              </Box>
            </>
          )}
        </Box>

        {/* {middleware?.state ? (
        <></>
      ) : null} */}
      </Modal>
      <HoldDownShift
        open={holdShift}
        handleClose={() => setHoldShift(false)}
        onUpdate={fetchEvents}
      />
    </>
  );
}

Calendar.propTypes = {
  open: PropTypes.bool,
  handleClose: PropTypes.func,
};